import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BrandLogo } from "./Brand";

export default function Preloader() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("mhm-intro"));

  useEffect(() => {
    if (!show) return undefined;
    const t = setTimeout(() => {
      sessionStorage.setItem("mhm-intro", "1");
      setShow(false);
    }, 1500);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] grid place-items-center bg-navy"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex flex-col items-center">
            <motion.div initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}>
              <BrandLogo size="lg" />
            </motion.div>
            <div className="mt-8 h-[2px] w-48 overflow-hidden bg-white/10">
              <motion.div className="h-full bg-brand" initial={{ x: "-100%" }} animate={{ x: "0%" }} transition={{ duration: 1.3, ease: "easeInOut" }} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
